import { render, staticRenderFns } from "./CurrentUserMenu.vue?vue&type=template&id=7c0c99b0&scoped=true&"
import script from "./CurrentUserMenu.vue?vue&type=script&lang=ts&"
export * from "./CurrentUserMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentUserMenu.vue?vue&type=style&index=0&id=7c0c99b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0c99b0",
  null
  
)

export default component.exports